import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../resources/requestInfo";
import { getPartnerIdFromStorage } from "../../../../utils/storage/partnerId";

import { updateUserInfoRoutes } from "./routes";

export interface IUpdateUserInfoData {
  name: string;
  phone: string;
  email: string;
  partner_id?: string;
}

export interface IUpdateUserInfoResponse {
  id: number;
  name: string;
  phone: string;
  email: string;
  phoneChangeRequested?: boolean;
  phoneChangeTo?: string;
}

export const fetchUpdateUserInfo = createAsyncThunk<IUpdateUserInfoResponse, IUpdateUserInfoData>(
  "updateUserInfo/fetchUpdateUserInfo",
  async (data, { rejectWithValue, getState }) => {
    try {
      const partnerIdFromStorage = getPartnerIdFromStorage();
      const partnerId = data.partner_id || partnerIdFromStorage || '';
      
      const requestData = {
        name: data.name,
        phone: data.phone,
        email: data.email,
        partner_id: partnerId
      };

      const response = await axiosInstance.put(updateUserInfoRoutes.UPDATE_USER, requestData);
      return response.data;
    } catch (error: any) {
      console.log("error fetchUpdateUserInfo >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка обновления информации о пользователе");
    }
  }
);
